import React from "react";
import cc from "classcat";
import PropTypes from "prop-types";
import { twMerge } from "tailwind-merge";
import SidebarMobile from "./SidebarMobile";
import { useSelector } from "react-redux";
import { screenBreakpointsSelectors } from "../../../redux/screenBreakpoints";
Sidebar.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    shouldHideSidebar: PropTypes.bool,
    setShouldHideSidebar: PropTypes.func.isRequired
};
export default function Sidebar(param) {
    var children = param.children, className = param.className, shouldHideSidebar = param.shouldHideSidebar, setShouldHideSidebar = param.setShouldHideSidebar;
    var overLg = useSelector(screenBreakpointsSelectors.isOver("lg"));
    return /*#__PURE__*/ React.createElement("aside", {
        className: "sidebar hidden -translate-x-full transform border-r-2 border-r-gray-200 bg-blue-50 transition-transform duration-150 ease-in dark:border-r-blue-750 dark:bg-blue-800 md:translate-x-0 md:shadow lg:block"
    }, overLg && /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "bg-blue-50",
            "w-80",
            "flex",
            "flex-col",
            "min-h-screen",
            "dark:bg-blue-800",
            className
        ]))
    }, children), !overLg && /*#__PURE__*/ React.createElement(SidebarMobile, {
        shouldHideSidebar: shouldHideSidebar,
        setShouldHideSidebar: setShouldHideSidebar
    }, /*#__PURE__*/ React.createElement("div", {
        className: cc([
            "dark:bg-blue-800",
            "bg-blue-50",
            "w-80",
            "flex",
            "flex-col",
            "h-full",
            "overflow-auto",
            className
        ])
    }, children)));
}
